import gql from 'graphql-tag';
import { editorBlockContentFragment } from './editor-block-content.fragment';

export const editorBlockQuery = gql`
  query editorBlock($id: String!) {
    editorBlock(id: $id) {
      id
      entityId
      userId
      contentId
      pdfPageCount
      previewThumbUrl
      content {
        ...editorBlockContentFragment
      }
    }
  }
  ${editorBlockContentFragment}
`;

export const imageLibrarySearchQuery = gql`
  query imageLibrarySearch($search: String!, $page: Float, $perPage: Float) {
    imageLibrarySearch(search: $search, page: $page, perPage: $perPage) {
      total
      totalPages
      images {
        id
        url
        rawUrl
        username
        name
        altDescription
      }
    }
  }
`;

export const trackImageLibraryDownloadQuery = gql`
  query trackImageLibraryDownload($imageId: String!) {
    trackImageLibraryDownload(imageId: $imageId)
  }
`;
